import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/retail-pricing",
    name: "Retail Pricing",
    component: () => import("./retailPriceManager.vue"),
  },
  {
    path: "/utilities",
    name: "Utilities Manager",
    component: () => import("./utilityManager.vue"),
  },
] satisfies RouteRecordRaw[];
